var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{staticClass:"is-danger",attrs:{"active":_vm.isNotificationActive},on:{"update:active":function($event){_vm.isNotificationActive=$event}}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }